import { 
    SET_GENERAL
} from '../actions';


// Inital zoom and center
const initialState = {
};

export default function(state = initialState, action:any){
    switch(action.type){
        case SET_GENERAL:
            return{
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}